import { $t } from '@/i18n';
import fetch from '@utils/fetch';
import wujiFetch from '@/utils/wujiFetch';
import { getRuntimeEnvPath } from '@config/constant';
import { message } from '@utils/wuji-message';

export const postEmail = async (to, title, content, { cc = '', bcc = '', emailId = '' }) => {
  const { projectId = '', env = 'dev' } = window.w || {};
  const api = emailId ? `${getRuntimeEnvPath(env)}/email` : '/api/xy/email';
  const data = {
    emailId,
    to,
    title,
    content,
    cc,
    bcc,
  };
  try {
    await wujiFetch(`${api}?projectid=${projectId}`, {
      method: 'POST',
      body: JSON.stringify(data),
    });
  } catch (error) {
    message.error($t('k_a04eeb3a'));
    throw error;
  }
};

export const notifyByWework = async (projectId, env, { receivers, msgType, data }, builtin = true) => {
  const url = getRuntimeEnvPath(env);
  try {
    await fetch(`${url}/notice/wework?projectid=${projectId}&builtin=${builtin}`, {
      method: 'POST',
      body: JSON.stringify({
        receivers,
        msgType,
        data,
      }),
    });
  } catch (error) {
    message.error($t('k_564045b4'));
    throw error;
  }
};

export const notifyByWeworkCustomer = async (projectId, env, { receivers, msgType, data }) => {
  const url = getRuntimeEnvPath(env);
  try {
    await fetch(`${url}/notice/customer?projectid=${projectId}`, {
      method: 'POST',
      body: JSON.stringify({
        receivers,
        msgType,
        data,
      }),
    });
  } catch (error) {
    message.error($t('k_cb0c139c'));
    throw error;
  }
};

export default {};
